export enum ConfirmationCodeErrorMessagesEnum {
  CODE_IS_NOT_VALID = "Code is not valid",
  CODE_EXPIRED = "Code expired",
  PHONE_IS_NOT_VALID = "Phone is not valid",
  SMS_LIMIT_EXCEEDED = "SMS limit exceeded",
}
